module.exports = __webpack_public_path__ + "static/connect-292db8171ae1e1435fade0533cb7d7f3.jpeg";